(() => {
  const root = document.documentElement;
  let frame = 0;
  let preview = null;
  const update = () => {
    frame = 0;
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    const bottom = (viewport ? viewport.offsetTop : 0) + height;
    const bounds = preview ? preview.getBoundingClientRect() : null;
    const inset = bounds && bounds.width > 0 && bounds.height > 0
      ? Math.max(0, Math.min(bounds.height, bottom - bounds.top))
      : 0;
    root.style.setProperty('--sb-search-visible-height', height + 'px');
    root.style.setProperty('--sb-search-bottom-inset', inset + 'px');
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const previewResize = new ResizeObserver(schedule);
  const findPreview = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next && next !== preview) {
      if (preview) previewResize.unobserve(preview);
      preview = next;
      previewResize.observe(preview);
    }
    schedule();
  };
  window.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  const additions = new MutationObserver(findPreview);
  additions.observe(document.body, { childList: true });
  window.addEventListener('pageshow', findPreview);
  findPreview();
})();
